export const psd_parse_url = '/node/psd/parse';
export const login_url = '/auth/login';
export const logout_url = '/auth/logout';
export const ps_url = process.env.VUE_APP_PS_URL; //'http://10.242.66.156:8080';
export const brand_logo_url = process.env.VUE_APP_BRAND_LOGO_URL;
export const screenshot_templates_url = `/screenshot?url=${process.env.VUE_APP_SCREEHSHOT}/template/`;
export const screenshot_template_url = `/screenshot?url=${process.env.VUE_APP_SCREEHSHOT}/templates/`;
export const screenshot_works_url = `/screenshot?url=${process.env.VUE_APP_SCREEHSHOT}/works/`;
export const screenshot_work_url = `/screenshot?url=${process.env.VUE_APP_SCREEHSHOT}/work/`;
export const cp_hidden_routers = ['user-action', 'project-management', 'project-approval', 'user-management', 'project-apply'];
export const linear_gradient_colors = [];
export const material_type = {
  element: 'ELEMENT',
  bg: 'BG',
  textGroup: 'TEXT'
};
export const iframe_data_key = {
  allInfo: 'allInfo', sizeInfo: 'sizeInfo'
};
export const role_map = {
  PROJ_USER: '普通成员',
  PROJ_ADMIN: '管理员',
  SYS_ADMIN: '系统管理员'
};
export const error_code_40001 = 400001; //名称重复
export const error_code_400003 = 400003; //模板不存在

export const MENU_DATA = [
  {
    path: '/',
    redirect: '/template',
    children: [
      {
        path: '/template',
        name: 'template',
        meta: {
          title: '模板库',
        },
      },
    ]
  },
  {
    path: '/',
    redirect: '/template/public',
    name: 'template-public',
    children: [
      {
        path: '/template/public',
        name: 'template-public',
        meta: {
          title: '模板广场',
        },
      },
    ]
  },
  {
    path: '/works/',
    meta: {
      title: '作品库',
    },
    children: [
      {
        path: 'my',
        name: 'my-works',
        meta: {
          title: '我的作品',
        },
      },
      {
        path: 'team',
        name: 'my-team',
        meta: {
          title: '团队作品',
        },
      },
    ]
  },
  {
    path: '/material/',
    meta: {
      title: '素材库',
    },
    children: [
      {
        path: 'imgs',
        meta: {
          title: '图片素材',
        },
        name: 'material-img',
      },
      {
        path: 'bgImgs',
        meta: {
          title: '背景素材',
        },
        name: 'material-bg-img',
      },
      {
        path: 'bgColor',
        meta: {
          title: '背景颜色',
        },
        name: 'material-bg-color',
      },
    ]
  }
];
export const empty_template = {
  id: null,
  projectId: '',
  defaultUrl: '',
  name: '',
  tagNames: [],
  type: '',
  json: {
    width: 0,
    height: 0,
    backgroundColor: 'RGBA(0,0,0,0)',
    children: [],
    data: [],
    isCustomer: false,
    customSize: {
      minWidth: null,
      minHeight: null,
      width: null,
      height: null,
    }
  },
  group: '',
  workTagIds: [],
  groupId: null
};
let TEXT_BG_SET = {
  height: null,
  color: '',
  bottom: null
}
export const text_bg_set = {...TEXT_BG_SET};
export const empty_template_group = {
  id: null,
  projectId: '',
  defaultUrl: '',
  name: '',
  group: '',
  json: {
    id: null,
    name: null,
    width: null,
    height: null,
    children: [],
    backgroundColor: null,
    defaultTextBg: Object.assign({}, TEXT_BG_SET),
  },
};
export const minus_plus = {
  minus: '-',
  plus: '+'
}
export const template_type_single = 'SINGLE';
export const template_type_multiple = 'MULTIPLE';
export const template_type_free = 'FREE';
export const template_type_ppt = 'PPT';
export const group_type_pt = 'PT';
export const group_type_mk = 'MK';
export const group_type_fa = 'FA';
export const module_group_edit = {
  'one': '1',  // 1： 添加 、删除、复制  2： 只可插入
  'two': '2'
}
export const template_type_mapping = {
  MULTIPLE: '图文',
  SINGLE: 'banner',
  PPT: 'PPT',
  FREE: '自由模板'
}
export const empty_tpl_group_works = {
  id: '',
  name: '',
  tplGroupId: null,
  type: template_type_multiple,
  size: '',
  url: '',
  widthHeight: '',
  projectId: '',
  workTagIds: [],
  json: {dataList: []},
};
export const tinymce_default_fonts = '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif';
export const theme_type_color = 'THEME';
export const theme_type_bg = 'BG_IMG_THEME';
export const img_horizontal = 'horizontal';
export const img_vertical = 'vertical';
export const img_two_direction = 'two-direction';
export const news_status = {
  pending: 'PENDING',
  withdraw: 'WITHDRAW',
  normal: 'NORMAL'
}
export const news_status_names = {
  PENDING: '未生效',
  NORMAL: '正常',
  WITHDRAW: '已下架'
}
export const time_selections = [{
  label: '最近一周',
  value: '1',
}, {
  label: '最近一个月',
  value: '2',
}, {
  label: '最近三个月',
  value: '3',
}, {
  label: '最近半年',
  value: '4',
}, {
  label: '最近一年',
  value: '5',
}, {
  label: '全部时间',
  value: '6',
}];
export const banner_rules = {
  'imgHorizontalExpansion': '横向扩展'
};
export const layer_text = {
  layerOrigin: 'psd',
  type: 'text',
  name: '',
  originName: '',
  key: null,
  left: null,
  top: null,
  bottom: null,
  right: null,
  opacity: null,
  width: null,
  height: null,
  hide: false,
  zIndex: null,
  htmlStr: null,
  htmlViewImg: null,
  isEditableTable: null,
  allowHide: null,
  fixed: null,
  disabled: null,
  max: null,
  isActionText: null,
  isMoreRow: null,
  autoWidth: false,
  lineHeight: null,
  centerHorizontal: null,
  centerVertical: null,
  textAlign: null,
  fontSize: null,
  fontFamily: null,
  fontWeight: 'normal',
  textShadow: '',
  boxShadow: '',
  color: null,
  colorValueList: null,
  letterSpacing: null,
  scale: null,
  transformOrigin: null,
  backgroundColor: null,
  missingFont: false,
  extendedAtt: null,
  fontStyle: null,
  fixedColor: null,
  rotate: 0,
  scaleX: 1,
  scaleY: 1,
  textShadowMap: null,
  gradientColors: '',
}
export const layer_img = {
  layerOrigin: 'psd',
  type: 'img',
  name: null,
  originName: null,
  url: null,
  key: null,
  left: 0,
  top: 0,
  bottom: null,
  right: null,
  width: null,
  height: null,
  zIndex: null,
  color: '',
  hide: false, // 整个图层是否隐藏
  htmlViewImg: null,
  isEditableTable: null,
  allowHide: null,
  fixed: null,
  disabled: null,
  opacity: null,
  backgroundColor: null,
  boxShadow: '',
  borderRadius: false,
  isCircle: null,
  showImg: true, //控制是否用div来显示button样式
  isBgImg: null,// 图层组内背景图片
  isPageBgImg: false,
  isBgMaterialImg: null, // 背景上的素材，可跟随背景移动
  isMaterial: null,
  direction: null,
  isGroupMaterial: null,
  materialGroup: null,
  coverObj: null,
  rotate: 0,
  scaleX: 1,
  scaleY: 1,
  textStrokeObj: null,
}
export const pt_group_item = {
  top: null,
  left: null,
  name: null,
  width: null,
  type: 'img',
  url: null,
  height: null,
}
export const language_map = {
  'CHINESE': '中文',
  'ENGLISH': '英文',
  'COMMON': '通用',
  'UNDEFINED': '未分类'
};
export const platform_map = {
  'WINDOWS': 'win',
  'MAC': 'mac',
  'COMMON': '通用',
  'UNDEFINED': '未分类'
};
export const platform_list = [{
  name: '通用',
  value: 'COMMON'
}, {
  name: 'Mac系统',
  value: 'MAC'
}, {
  name: 'Windows系统',
  value: 'WINDOWS'
}, {
  name: '未分类',
  value: 'UNDEFINED'
}];
export const language_list = [{
  name: '通用',
  value: 'COMMON'
}, {
  name: '中文',
  value: 'CHINESE'
}, {
  name: '英文',
  value: 'ENGLISH'
}, {
  name: '未分类',
  value: 'UNDEFINED'
}];
export const project_set = {
  SHOW_FIXED_TEMPLATE: '',
  SHOW_FREE_TEMPLATE: '',
  SHOW_PUBLIC_PROJECT: '',
  UPLOAD_FIXED_TEMPLATE: '',
  UPLOAD_FREE_TEMPLATE: '',
  SHOW_PRELIMINARY_TEMPLATE: '',
  CONNECT_TO: null,
  SHOW_TEAM_WORK: '',
  YANXUAN_PIC_QUERY: ''
};
export const editor_tab_name = {
  template: 'template',
  material: 'material',
  bg: 'bg',
  text: 'text'
};
export const gradient_list = [
  ['#121317', '#323B42'],
  ['#9D2E7D', '#E16E93'],
  ['#F5CCF6', '#F1EEF9'],
  ['#A43AB2', '#E13680'],
  ['#BC3D2F', '#A16BFE'],
  ['#F78FAD', '#FDEB82'],
  ['#D279EE', '#F8C390'],
  ['#A16BFE', '#DEB0DF'],
  ['#5583EE', '#41D8DD'],
  ['#6CACFF', '#8DEBFF'],
  ['#ABC7FF', '#C1E3FF'],
  ['#99E5A2', '#D4FC78'],
  ['#41C7AF', '#54E38E'],
  ['#6DE195', '#C4E759']
];